import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcToggleComponent} from './ac-toggle.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {InfraPipesModule} from "../../pipes/infra.pipes.module";

@NgModule({
    imports: [
        MatSlideToggleModule,
        CommonModule,
        FormsModule,
        InfraPipesModule
    ],
    declarations: [
        AcToggleComponent,
    ],
    entryComponents: [
        AcToggleComponent,
    ],
    exports: [
        AcToggleComponent,
    ]
})
export class AcToggleModule {
}
